import React from 'react';
import classNames from 'classnames';
import styles from './Divider.module.scss';

export const Divider = ({ children, className }: Props) => {

    const classes = classNames(styles.divider, className, {
        [styles.empty]: !children
    });

    return (
        <div className={classes}>
            {children}
        </div>
    );
};

type Props = {
    className?: string;
    children?: string;
};